import NodeDataEngine from 'bdata-react-component/lib/dataEngine/NodeDataEngine';
import MessageService from 'message-service/message-service';
import DistEvents from '../events/DistEvents';
import DataEvents from '../events/DataEvents';
const { UPDATE_ALL, REFRESH_LIVE, REFRESH_PREGAME } = DistEvents;
const { INIT_DATA_LOADED, UPDATE } = DataEvents;

const gamedayDataEvents = {
    INIT_DATA_LOADED,
    UPDATE,
    UPDATE_ALL,
    REFRESH_LIVE,
    REFRESH_PREGAME
};

class GamedayNodeDataEngine extends NodeDataEngine {
    constructor (_opts) {
        super(_opts);
        this.previousGamePk = null;
        this.forceUpdate = false;
        this.previousHideScoresSetting = false;
        this.hideScoreSetting = false;
    }

}

GamedayNodeDataEngine.prototype.engineActions = { ...NodeDataEngine.prototype.engineActions, ...gamedayDataEvents };

export default GamedayNodeDataEngine;
